import { render, staticRenderFns } from "./CadastrarCaixa.vue?vue&type=template&id=44938560&scoped=true&"
import script from "./CadastrarCaixa.vue?vue&type=script&lang=js&"
export * from "./CadastrarCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44938560",
  null
  
)

export default component.exports